





class SafeProxy



 {
  

  constructor(proxy) {
    this.proxy = proxy
  }

  getValue(name, args) {
    // help wanted: how to remove the cast?
    if (!this.proxy) return null
    return this.proxy.getValue(name , args)
  }

  getLinkedRecord(name, args) {
    const proxy = this.proxy ? this.proxy.getLinkedRecord(name , args) : null
    return new SafeProxy(proxy)
  }

  getLinkedRecords(
    name,
    args
  ) {
    const records = this.proxy ? this.proxy.getLinkedRecords(name , args) : null
    return records ? records.map((record) => new SafeProxy(record)) : new SafeProxy(null)
  }
}

const safeProxy = (proxy) => new SafeProxy(proxy)

export default safeProxy
